export const loadScript = (src: string, globalVar?: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (globalVar && (window as any)[globalVar]) {
      resolve()
      return
    }

    const existingScript = document.querySelector(`script[src="${src}"]`)
    if (existingScript) {
      if (globalVar && (window as any)[globalVar]) {
        resolve()
      } else {
        let count = 0
        const check = setInterval(() => {
          count++
          if (globalVar && (window as any)[globalVar]) {
            clearInterval(check)
            resolve()
          }
          if (count > 100) {
            clearInterval(check)
            if (globalVar && !(window as any)[globalVar]) {
              reject(new Error(`Timeout waiting for global variable: ${globalVar}`))
            } else {
              resolve()
            }
          }
        }, 100)
      }
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src
    script.onload = () => {
      resolve()
    }
    script.onerror = (e) => {
      reject(e)
    }
    document.head.appendChild(script)
  })
}
